import { evmTxHistoryList } from '@/api/evmScan/txList';
import { useWeb3 } from '@/hooks/use-web3';
import { LOCAL_SESSION, LOCAL_SESSION_TIME } from '@/lib/common/name-space';
import { EvmTxHistory } from '@/types';
import { useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';
import Holdings from '../../component/pools/Holdings';
import PoolHistory from '@/component/pools/PoolHistory';

import { useTheme } from '@mui/material';
import CommonTop from '@/component/pools/CommonTop';
import PoolsOverview from '@/component/pools/card/PoolsOverview';
import CommonButton from '@/component/pools/CommonButton';
import { localGetStorage, localSetStorage } from '@/lib/storage';

// TODO 컨트랙트 주소를 받아야 한다.
export default function PortfolioMain() {
  // const address = useRef<string>('');
  const [address, setAddress] = useState('');
  const [list, setList] = useState<EvmTxHistory[] | null>(null);

  const { web3authCall } = useWeb3();
  const theme = useTheme();

  useEffect(() => {
    if (address) {
      return;
    }
    (async () => {
      if (web3authCall?.connected()) {
        const addr = await web3authCall.getAddress();
        setAddress(addr);

        await addrTxList(addr);
      }
    })();
    return () => {};
  }, [web3authCall]);

  const addrTxList = async (aAddress: string) => {
    if (!web3authCall?.connected()) {
      return;
    }
    const re: EvmTxHistory[] = await evmTxHistoryList(aAddress);
    if (!re?.length) {
      return;
    }
    // evmList = re;
    setList(re);
  };

  const handleConnectWallet = async () => {
    console.log(`ddd`);
    const re = await web3authCall?.getWeb3auth().connect();
    if (re) {
      const userAccount: string[] = await web3authCall?.getRpc().getAccounts()!;
      console.log(userAccount[0]);
      if (userAccount[0]) {
        const userInfo = await web3authCall?.getUserInfo();
        console.log(userInfo?.typeOfLogin);

        const re = localGetStorage(LOCAL_SESSION);
        if (!re) {
          setSession();
          changeLoginType();
        }
        window.location.reload();
      }
    }
  };
  const setSession = () => {
    const now = new Date();
    const payload = {
      key: LOCAL_SESSION,
      value: {
        sessionTime: now.getTime() + LOCAL_SESSION_TIME,
      },
    };
    localSetStorage(payload);
  };
  const changeLoginType = async () => {
    const res = localGetStorage('snsAddress');
    if (!res) {
      return;
    }
    const re = await web3authCall!.getUserInfo();
    const loginType = re.typeOfLogin ?? 'external';
    const payload = {
      key: 'snsAddress',
      value: {
        ...res,
        typeOfLogin: loginType,
      },
    };
    localSetStorage(payload);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', md: '0px' },
        }}
      >
        {/* Pools Title Section */}
        <CommonTop title="Portfolio" subtitle="Track And Manage Your Portfolio">
          <Box
            sx={{
              padding: '16px 24px',
              maxWidth: { xs: '1920px', md: '352px' },
            }}
          >
            {/* <PoolsOverview title="Total Staked Value" content="0 USD" /> */}
          </Box>
        </CommonTop>
        {!address && (
          <Box sx={{ padding: '24px', maxWidth: '1111px' }}>
            <Typography variant="subtitle1" color="#232323">
              To view your investments, you need to connect your wallet.
            </Typography>
            <CommonButton
              sx={{
                marginTop: '16px',
                width: { xs: '100%', md: '288px' },
                borderRadius: '10px',
              }}
              color={address ? '#ffffff' : theme.background.blue}
              bgColor={address ? theme.background.blue : '#ffffff'}
              text={address ? 'Stake' : 'Connect Wallet'}
              handleClick={handleConnectWallet}
              border={theme.background.blue}
              variant={address ? 'h5' : 'h6'}
            />
          </Box>
        )}

        {/* Holdings */}
        <Holdings aList={list} aAddress={address} />

        {/* Transaction History */}
        <PoolHistory aList={list} aAddress={address} />
      </Box>
    </>
  );
}
